import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async ({ resource_name, changes }, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({
      method: 'PUT',
      path: `/settings/media-guide/${resource_name}`,
      body: changes, // only the fields that changed
    });
    return { mediaGuide: data };
  } catch (error) {
    console.error('services.mediaguides.updateMediaGuide@handler', error);
    return rejectWithValue({ status: error.status, message: error.message });
  }
};

const pending = (state) => ({ ...state, updating: true });
const fulfilled = (state, action) => ({
  ...state,
  updating: false,
  lists: state.lists.map((m) =>
    m.resource_name === action.payload.mediaGuide.resource_name ? action.payload.mediaGuide : m
  ),
});
const rejected = (state) => ({ ...state, updating: false });

export default { handler, pending, fulfilled, rejected };
